import { render, staticRenderFns } from "./GiftSerialHeader.vue?vue&type=template&id=11376f34&scoped=true&"
import script from "./GiftSerialHeader.vue?vue&type=script&lang=js&"
export * from "./GiftSerialHeader.vue?vue&type=script&lang=js&"
import style0 from "./GiftSerialHeader.vue?vue&type=style&index=0&id=11376f34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11376f34",
  null
  
)

export default component.exports